module.exports = __webpack_public_path__ + "media/images/front/pc/for-doctors/img_cs-3403e8a77deb9862e2198a600ddd2b4c.png";